export default {
    "wealthUltima": "40073",
    "zindagiPlus": "40038",
    "activeIncomePlan": "40035",
    "simplyProtect": "40012",
    "wealthPlus": "40023",
    "wealthGainPlus": "40030",
    "wealthSecurePlus": "40031",
    "criticarePlus": "40014",
    "GCAP": "40007",
    "smartLifestyle": "40005",
    "dhanLabh": "40015",
    "cashFlowProtectionPlus": "40004",
    "incomeBuilder": "40060",
    "immediateAnnuityPlan": "40020",
    "wealthPremier": "40034",
    "easyPension": "40032",
    "singlePayEndowmentAssuarancePlan": "40019",
    "posSaralNivesh": "40059",
    "protection": "40011",
    "totalProtectPlus": "40044",
    "saralJeevanBima": "40039",
    "saralPension": "40041",
    "foreverPension": "40040",
    "premierGuranteedIncome": "40061",
    "premierGuranteedStar": "40072",
    "guaranteedIncomeStar": "40062",
    "guaranteedSavingsStar": "40063",
    "flexiSavingsPlan": "40064",
    "zindagiProtect": "40069",
    "bharatSavingsStar": "40066",
    "legacyPlus": "40068",
    "activePensionPlus": "40074",
    "guaranteedFlexStar": "40071",
    "flexiDreamPlan": "40075",
    "assuredIncomeStar": "40077",
    "flexiGoalSecure": "40078",
    "premierGuranteedStarPro": "40076",
}